var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGreenDot = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    isolation: "isolate"
  },
  viewBox: "0 0 4 4",
  width: 4,
  height: 4,
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: " M 2 0 C 0.9 0 0 0.9 0 2 C 0 3.1 0.9 4 2 4 C 3.1 4 4 3.1 4 2 C 4 0.9 3.1 0 2 0 Z",
  fill: "#80BB00"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGreenDot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/greenDot.9d8be50b6dc0e7ac432091846c8f057b.svg";